import { DayName, getAccessProfile, getIsParkingFeatureVisible, getParkingQuotaProfile } from "@lib/store";

import { useTranslation } from "react-i18next";

import { useAppSelector } from "@hooks";
import { StyledQuotaCard } from "./styles";

export const QuotaCard = () => {
  const { t } = useTranslation();

  const locationQuotaProfile = useAppSelector(getAccessProfile);

  const isParkingFeatureVisible = useAppSelector(getIsParkingFeatureVisible);

  const parkingQuotaProfile = useAppSelector(getParkingQuotaProfile);

  const daysInAWeek = 7;
  const shiftsEachWeekText = t("profile:WorkspaceEachWeek", { count: locationQuotaProfile.daysPerWeek });

  const onWeekDaysText = t("profile:OnWeekDays");
  const weekDays: DayName[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  const isAllWeek = locationQuotaProfile.registrationDays.length === daysInAWeek;
  const isWeekDaysOnly =
    locationQuotaProfile.registrationDays.length === weekDays.length &&
    weekDays.every(d => locationQuotaProfile.registrationDays.includes(d));
  const allowedDaysText = isAllWeek
    ? ""
    : isWeekDaysOnly
      ? onWeekDaysText
      : locationQuotaProfile.registrationDays.reduce((previous, next, idx: number) => {
          if (locationQuotaProfile.registrationDays.length === 0) {
            return "";
          }
          if (locationQuotaProfile.registrationDays.length === 1) {
            return next;
          }
          return idx === 0
            ? next
            : idx === locationQuotaProfile.registrationDays.length - 1
              ? `${t(previous as DayName)} ${t("And").toLowerCase()} ${t(next as DayName)}`
              : `${t(previous as DayName)}, ${t(next as DayName)}`;
        }, "");
  const isAllowedDaysShown = allowedDaysText !== "";

  const getDaysAheadLabel = (labelType: "workday" | "parking", daysAhead: number) => {
    const context = daysAhead % daysInAWeek === 0 ? "weeks" : "days";
    const count = context === "weeks" ? daysAhead / daysInAWeek : daysAhead;

    const translationKey = labelType === "parking" ? "profile:ParkingInAdvance" : "profile:InAdvance";
    return t(translationKey, { context, count });
  };

  const workdayDaysAheadLabel = getDaysAheadLabel("workday", locationQuotaProfile.daysAhead);
  const parkingDaysAheadLabel = getDaysAheadLabel("parking", parkingQuotaProfile.daysAhead);

  return (
    <StyledQuotaCard lineHeight="body">
      <ul>
        <li>{shiftsEachWeekText}</li>
        {isParkingFeatureVisible && (
          <li>{t("parking:ParkingSpotEachWeek", { count: parkingQuotaProfile.daysPerWeek })}</li>
        )}

        <li className="text-balance">{workdayDaysAheadLabel}</li>
        <li className="text-balance">{parkingDaysAheadLabel}</li>

        {isAllowedDaysShown && <li>{allowedDaysText}</li>}
      </ul>
    </StyledQuotaCard>
  );
};
